import {RefObject} from 'react';

export const scrollToSelectedTime = (
  selectedTimeRef: RefObject<HTMLLIElement | null>,
  startTimeIndex: number,
) => {
  return (node: HTMLDivElement) => {
    if (!node || !selectedTimeRef.current) {
      return;
    }
    const timeListHeight = node.getBoundingClientRect().height;
    const timeSlotHeight =
      selectedTimeRef.current.getBoundingClientRect().height;

    // Calculate how many time slots are visible in the list and then divide by 2.
    // This gives us the number of slots that need to be visible above the selected item
    // in order for it to be in the middle of the list. e.g if the list height is 300px
    // and the item height is 44px then:
    // 300 / 44 / 2 = 3.4
    // The division by 2 gives us the centre of the visible rows
    const centerOfVisibleTimeSlots = timeListHeight / timeSlotHeight / 2;

    // Calculate where the list should be scrolled to using
    // the index of the selected time slot
    const selectedTimeScrollPosition =
      // when the index is less than the middle of the viewport just return
      // 0 so it always scrolls to the top
      startTimeIndex <= centerOfVisibleTimeSlots
        ? 0
        : // subtract the centre value from the start time index to give us a value
          // starting from the middle of the time slot list
          // e.g the selected time is index 5 and the middle is 3.6
          // (5 - 3.4) = 1.6
          // now multiply this by the height of a time slot (44px) to get a scroll position
          // 1.4 * 44 = 70.4
          // This will move it just to the top of the time slot so we also add half the
          // height to ensure it is centered
          // Essentially scrolling the list by 1.6 timeslots
          (startTimeIndex - centerOfVisibleTimeSlots) * timeSlotHeight +
          timeSlotHeight / 2;

    node.scrollTo({
      top: selectedTimeScrollPosition,
      behavior: window.Cypress ? 'auto' : 'smooth',
    });
  };
};
